import { RG_TYPE } from '../../types/rg-type.js';

const DefaultOpening = {
    type: RG_TYPE.Opening,
    size: [1, 1, 0.11],
    anchor: [0.5, 0, 0.5],
    name: 'wall opening',
    children: [],
    color: '#4469BE'
};

export { DefaultOpening };
//# sourceMappingURL=default-opening.js.map
